<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <div contenido class="classContenido">
    <!-- Institución selector debajo del titulo -->
    @if (isAdministrador && instituciones.length > 0) {
      <div style="padding: 20px 0; text-align: center; position: relative;">
        <div 
          style="font-size: 16px; color: #ff6600; font-weight: bold; cursor: pointer; display: inline-block;"
          (click)="toggleDropdown()">
          {{ getInstitucionNombre() }}
        </div>
        
        <!-- Dropdown de instituciones -->
        @if (mostrarDropdownInstitucion) {
          <div style="position: absolute; top: 50px; left: 50%; transform: translateX(-50%); background: white; border: 1px solid #ddd; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); z-index: 1000; min-width: 250px;">
            @for (inst of instituciones; track inst.id) {
              <div (click)="seleccionarInstitucion(inst.id)"
                  style="padding: 12px 16px; cursor: pointer; border-bottom: 1px solid #eee; transition: background 0.2s; background: white;"
                  [style.background]="inst.id === formResponsables.get('institucion')?.value ? '#f5f5f5' : 'white'">
                {{ inst.name }}
              </div>
            }
          </div>
        }
      </div>
    }
    
    <!-- Cerrar dropdown al hacer click fuera -->
    @if (mostrarDropdownInstitucion) {
      <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 999;"
          (click)="toggleDropdown()"></div>
    }


    <!--Tabla de Puestos/Cargos-->
    <div class="tabla-contenedor">
      <div class="tabla-header">
        <div class="agregar-responsable" (click)="abrirModal()">
          <mat-icon class="icono-agregar-responsable">add_circle_outline</mat-icon>
          <span>{{ 'responsables-planes.agregar-responsable' | translate }}</span>
        </div>
      </div>
      <div class="tabla">
        <table class="w3-table tabla-empleados">
          <thead>
            <tr>
              <th>{{ 'responsables-planes.puesto' | translate }}</th>
              <th>{{ 'responsables-planes.nombre' | translate }}</th>
              <th>{{ 'responsables-planes.correo' | translate }}</th>
              <th>{{ 'responsables-planes.acciones' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (responsable of responsables; track $index) {
              <tr>
                <td>{{ responsable.role_name }}</td>
                <td>{{ responsable.name }} {{ responsable.last_name }} {{ responsable.last_name2 }}</td>
                <td>{{ responsable.email }}</td>
                <td class="acciones-celda">
                  <mat-icon class=" icono-editar" (click)="editarResponsable(responsable)" [title]="'responsables-planes.editar' | translate">edit</mat-icon>
                  <mat-icon class=" icono-eliminar" (click)="eliminarResponsable(responsable.id)" [title]="'responsables-planes.eliminar' | translate">delete</mat-icon>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="mostrarModal" (close)="cerrarModal()" [cerrar]="false">
  <div modal-header>
    <h2>{{ editandoId ? ('responsables-planes.editar-responsable' | translate) : ('responsables-planes.nuevo-responsable' | translate) }}</h2>
  </div>
  
  <div modal-body>
    <div class="w3-row" style="width: 95%; margin: 1vh;" [formGroup]="formResponsables">
      <div class="form-row">
        <div class="form-group-inline">
          <label for="inputNombre" class="form-label">{{ 'responsables-planes.nombre-requerido' | translate }}</label>
          <input 
            id="inputNombre"
            type="text" 
            class="contentInput" 
            formControlName="nombre" 
            [placeholder]="'responsables-planes.ingrese-nombre' | translate">
        </div>

        <div class="form-group-inline">
          <label for="inputApellidoPaterno" class="form-label">{{ 'responsables-planes.apellido-paterno-requerido' | translate }}</label>
          <input 
            id="inputApellidoPaterno"
            type="text" 
            class="contentInput" 
            formControlName="apellidoPaterno" 
            [placeholder]="'responsables-planes.apellido-paterno-placeholder' | translate">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group-inline">
          <label for="inputApellidoMaterno" class="form-label">{{ 'responsables-planes.apellido-materno' | translate }}</label>
          <input 
            id="inputApellidoMaterno"
            type="text" 
            class="contentInput" 
            formControlName="apellidoMaterno" 
            [placeholder]="'responsables-planes.apellido-materno-placeholder' | translate">
        </div>

        <div class="form-group-inline">
          <label for="inputCorreo" class="form-label">{{ 'responsables-planes.correo-requerido' | translate }}</label>
          <input 
            id="inputCorreo"
            type="email" 
            class="contentInput" 
            formControlName="correo" 
            [placeholder]="'responsables-planes.correo-placeholder' | translate">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group-inline">
          <label for="inputPuesto" class="form-label">{{ 'responsables-planes.puesto-requerido' | translate }}</label>
          <input 
            id="inputPuesto"
            type="text" 
            class="contentInput" 
            formControlName="puesto" 
            [placeholder]="'responsables-planes.ingrese-puesto' | translate">
        </div>
      </div>
      @if(formResponsables.hasError('isValid')){
        <div style="font-size: 8pt; color: red; margin-left: 160px;">
          {{'gestion.formulacion.alta-actas.nombreExis'|translate}}
        </div>
      }
    </div>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="cerrarModal()"
  />
  <app-button modal-footer
    [ngClass]="{'w3-disabled': !formResponsables.valid}"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="guardar()"
  />
</app-modal>
